import styled from 'styled-components';

const SpaceForTab = styled.div`
  width: 100vw;
  background-color: #ffffff;
`;

export default SpaceForTab;
